const DEFAULTS = { threshold: 0.2, rootMargin: "0px", once: true }

let observer = null

export function initSal(opts = {}) {
    if (typeof window === "undefined") return

    const { threshold, rootMargin, once } = { ...DEFAULTS, ...opts }

    if (observer) observer.disconnect()

    const elements = document.querySelectorAll("[data-sal], .fade-in")

    if (!elements.length) return

    const obs = new IntersectionObserver(
        entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("sal-animate")
                    if (once) obs.unobserve(entry.target)
                } else if (!once) {
                    entry.target.classList.remove("sal-animate")
                }
            })
        },
        { threshold, rootMargin }
    )

    observer = obs

    elements.forEach(el => {
        if (el.getBoundingClientRect().top < 0) {
            el.classList.add("sal-animate")
            return
        }
        obs.observe(el)
    })
}
